import db from '..';
import {
  makeDefaultAddBatch,
  makeDefaultCount,
  makeDefaultGetMany,
  makeDefaultRemoveBatch,
} from '../defaultDaoFactories';
import { entityDbClearFactory } from '../entityDbClearFactory';
import { clear as issueFormServiceClear } from './issueFormService';
import { IssueFormEntity } from 'serviceWorker/repository/issueForm/issueForm';
import { issueFormContract } from 'shared/domain/issueForm/issueFormContract';
import { makeClearPublisher } from 'serviceWorker/broadcasts/publishers';

export const clear = entityDbClearFactory(
  db,
  ['issueForm', 'issueFormService'],
  () => db.issueForm.clear(),
  issueFormServiceClear,
  makeClearPublisher(issueFormContract)
);

export const quantity = makeDefaultCount<IssueFormEntity>(
  db,
  db.issueForm
);

export const get = makeDefaultGetMany<IssueFormEntity>(db, db.issueForm);

export const addBatch = makeDefaultAddBatch<IssueFormEntity>(
  db,
  db.issueForm
);

export const updateBatch = addBatch;

export const removeBatch = makeDefaultRemoveBatch<string, IssueFormEntity>(
  db,
  db.issueForm,
  'name'
);
